import DriverHistoryForm from "./Form";
import useDriverHistory from "./hooks/useDriverHistory";

export const DriverHistory = () => {
  const props = useDriverHistory();
  return <DriverHistoryForm {...props} />;
};

export default DriverHistory;
